/*! Copyright (c) Safe As Milk. All rights reserved. */
import Cart from "cart-store";

class CartLink extends HTMLElement {
    constructor() {
        super();
    }
}

customElements.define("cart-link", CartLink);
//# sourceMappingURL=cart-link.js.map
